import { createContext } from "react";

const RoutingContext = createContext({
  currentRoute: 0,
  setRoutIndex: () => {},
});

export default RoutingContext;
